export default __webpack_public_path__ + "static/media/id.578a8a9c.svg";